webpackJsonp([1],{

/***/ 128:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(93);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      showNavigation: false,
      showSidepanel: false,
      categories: ['Logical Fallacies', 'General Thinking Concepts', 'Numeracy', 'Systems', 'Physical World', 'The Biological World', 'Human Nature & Judgment', 'Microeconomics & Strategy', 'Military & War']
    };
  },
  watch: {
    categories: function categories() {
      console.log('this.categories', this.categories);
      this.$store.commit('SET_SELECTED_CATEGORIES', this.categories);
    }
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['modelList', 'categoryList', 'selectedCategories'])),
  methods: {
    categoryCount: function categoryCount(categoryName) {
      return this.modelList.filter(function (c) {
        return c.category === categoryName;
      }).length;
    },
    shuffle: function shuffle(array) {
      var currentIndex = array.length;
      var temporaryValue = void 0;
      var randomIndex = void 0;

      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array;
    },
    toggleSelectedCategories: function toggleSelectedCategories() {
      this.categories = this.selectedCategories.length === this.categoryList.length ? [] : this.categoryList.slice(0);
    }
  }
});

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EmptyCard__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ModelCard__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Form__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Signup__ = __webpack_require__(357);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  props: ['category', 'model'],
  components: { EmptyCard: __WEBPACK_IMPORTED_MODULE_1__EmptyCard__["a" /* default */], ModelCard: __WEBPACK_IMPORTED_MODULE_2__ModelCard__["a" /* default */], Form: __WEBPACK_IMPORTED_MODULE_3__Form__["a" /* default */], Signup: __WEBPACK_IMPORTED_MODULE_4__Signup__["a" /* default */] },
  mounted: function mounted() {
    // console.log('this.category', this.$route.params.category)
  },
  data: function data() {
    return {};
  },
  computed: _extends({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapGetters */])(['categoryCount', 'categoryList', 'cardIndex', 'modelList', 'selectedCategories']), {
    shuffledModels: function shuffledModels() {
      var _this = this;

      var filtered = this.modelList.filter(function (m) {
        return _this.selectedCategories.includes(m.category);
      });
      return this.shuffle(filtered);
    },
    currentModel: function currentModel() {
      return this.shuffledModels[this.cardIndex];
    }
  }),
  methods: {
    nextModel: function nextModel() {
      var i = this.cardIndex + 1 >= this.shuffledModels.length ? 0 : this.cardIndex + 1;
      this.$store.commit('SET_CARD_INDEX', i);
    },
    previousModel: function previousModel() {
      var i = this.cardIndex - 1 < 0 ? this.shuffledModels.length - 1 : this.cardIndex - 1;
      this.$store.commit('SET_CARD_INDEX', i);
    },
    shuffle: function shuffle(array) {
      var currentIndex = array.length;
      var temporaryValue = void 0;
      var randomIndex = void 0;

      // While there remain elements to shuffle...
      while (currentIndex !== 0) {
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;

        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
      }
      return array;
    }
  }
});

/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'EmptyCard',
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ 131:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['model'],
  name: 'ModelCard',
  data: function data() {
    return {};
  },
  methods: {
    nextModel: function nextModel() {
      this.$emit('onNext');
    },
    previousModel: function previousModel() {
      this.$emit('onPrevious');
    },
    google: function google(model) {
      var url = 'https://www.google.com/search?q=' + model.name;
      window.open(url, '_blank');
    }
  }
});

/***/ }),

/***/ 132:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['model'],
  name: 'EmptyCard',
  data: function data() {
    return {
      suggestion: ''
    };
  }
});

/***/ }),

/***/ 133:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: [],
  name: 'Subscribe',
  data: function data() {
    return {
      email: '',
      first: '',
      last: ''
    };
  }
});

/***/ }),

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(135);
module.exports = __webpack_require__(337);


/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_material___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_material__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_min_css__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_material_dist_vue_material_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_theme_default_css__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_material_dist_theme_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_material_dist_theme_default_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_material___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(128);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ce8e6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(344);
function injectStyle (ssrContext) {
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(46)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36ce8e6e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 342:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container md-layout-column"},[_c('md-toolbar',{attrs:{"md-elevation":"0"}},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.showNavigation = true}}},[_c('img',{attrs:{"src":"/static/img/icons/icon-128x128.png"}})])],1),_vm._v(" "),_c('md-drawer',{staticClass:"sidebar",attrs:{"md-active":_vm.showNavigation},on:{"update:mdActive":function($event){_vm.showNavigation=$event}}},[_c('div',{staticClass:"close-sidebar"},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function () {_vm.showNavigation = false}}},[_c('img',{attrs:{"src":"/static/img/x.svg","alt":"X"}})])],1),_vm._v(" "),_c('md-content',[_c('img',{staticClass:"main-logo",attrs:{"src":"/static/img/mm-logo.svg"}})]),_vm._v(" "),_c('md-list',[_c('md-subheader',[_vm._v("Filter Topics")]),_vm._v(" "),_c('md-list-item',{on:{"click":_vm.toggleSelectedCategories}},[_vm._v("Toggle All")]),_vm._v(" "),_vm._l((_vm.categoryList),function(c,index){return _c('md-list-item',{key:index},[_c('md-checkbox',{staticClass:"md-accent selected",attrs:{"value":c},model:{value:(_vm.categories),callback:function ($$v) {_vm.categories=$$v},expression:"categories"}}),_vm._v(" "),_c('span',{staticClass:"md-list-item-text"},[_vm._v(_vm._s(c)+" ("+_vm._s(_vm.categoryCount(c))+")")])],1)})],2),_vm._v(" "),_c('md-content',[_c('h3',{staticClass:"md-caption"},[_vm._v("About")]),_vm._v(" "),_c('p',[_vm._v("Mental models are \"core concepts\". They unchanging fundamentals for a particular subject."),_c('br'),_vm._v(" Learning these concepts will give you a better comprehension of the world and help you make rational decisions.")]),_vm._v(" "),_c('p',[_vm._v("This app is a shuffled list of "+_vm._s(_vm.modelList.length)+" mental models, grouped into "+_vm._s(_vm.categoryList.length)+" color-coded categories.")]),_vm._v(" "),_c('p',[_vm._v("Try to do a few each day. Spaced repetition will help you remember. If you are using a mobile you can add this page to your homescreen and use it offline.")])]),_vm._v(" "),_c('md-content',[_c('h3',{staticClass:"md-caption"},[_vm._v("Acknowledgements")]),_vm._v(" "),_c('p',[_c('small',[_vm._v("Credit for models")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{attrs:{"href":"https://www.farnamstreetblog.com/mental-models/","target":"_blank"}},[_vm._v("Farnam Street")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"https://yourlogicalfallacyis.com","target":"_blank"}},[_vm._v("Your Logical Fallacy Is")])])])]),_vm._v(" "),_c('md-content',[_c('h3',{staticClass:"md-caption"},[_vm._v("Support")]),_vm._v(" "),_c('p',[_c('small',[_vm._v("I don't plan to put adwords on this site, but if you want to show your support then check out one of my other sites. ")])]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{staticClass:"padded",attrs:{"href":"https://pollygot.com","target":"_blank"}},[_vm._v("Pollygot")])]),_vm._v(" "),_c('li',[_c('a',{staticClass:"padded",attrs:{"href":"https://braineebox.com","target":"_blank"}},[_vm._v("BraineeBox")])])])]),_vm._v(" "),_c('md-content',[_c('h3',{staticClass:"md-caption"},[_vm._v("Source Code")]),_vm._v(" "),_c('p',[_c('small',[_vm._v("You can find the source code for this app on "),_c('a',{attrs:{"href":"https://github.com/kiwicopple/mentalmodels","target":"_blank"}},[_vm._v("Github")])])])])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 345:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Models__ = __webpack_require__(347);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    props: true,
    name: 'Models',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Models__["a" /* default */]
  }]
}));

/***/ }),

/***/ 347:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Models_vue__ = __webpack_require__(129);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f84ad52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Models_vue__ = __webpack_require__(360);
function injectStyle (ssrContext) {
  __webpack_require__(348)
}
var normalizeComponent = __webpack_require__(46)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f84ad52"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Models_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f84ad52_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Models_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 348:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 349:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyCard_vue__ = __webpack_require__(130);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adb2ea4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyCard_vue__ = __webpack_require__(350);
var normalizeComponent = __webpack_require__(46)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adb2ea4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 350:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-primary empty-card"},[_c('md-card-header',[_c('md-card-header-text',[_c('div',{staticClass:"md-title"},[_vm._v("Choose Topics")])])],1),_vm._v(" "),_c('md-card-content',[_vm._v("\n     Select some topics in the sidebar to get started\n   ")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 351:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModelCard_vue__ = __webpack_require__(131);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8240be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModelCard_vue__ = __webpack_require__(353);
function injectStyle (ssrContext) {
  __webpack_require__(352)
}
var normalizeComponent = __webpack_require__(46)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6d8240be"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ModelCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d8240be_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ModelCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 352:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 353:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{staticClass:"md-primary",class:{
    'cyan-card': _vm.model.category === 'Logical Fallacies',
    'blue-card': _vm.model.category === 'General Thinking Concepts',
    'black-card': _vm.model.category === 'Numeracy',
    'purple-card': _vm.model.category === 'Systems',
    'green-card': _vm.model.category === 'Physical World',
    'orange-card': _vm.model.category === 'The Biological World',
    'pink-card': _vm.model.category === 'Human Nature & Judgment',
    'yellow-card': _vm.model.category === 'Microeconomics & Strategy',
    'red-card': _vm.model.category === 'Military & War',
  }},[_c('md-card-header',[_c('md-card-header-text',[_c('div',{staticClass:"md-title"},[_vm._v(_vm._s(_vm.model.name))]),_vm._v(" "),_c('div',{staticClass:"md-subhead"},[_vm._v(_vm._s(_vm.model.category))])]),_vm._v(" "),_c('md-menu',{attrs:{"md-size":"big","md-direction":"bottom-end"}},[_c('md-button',{staticClass:"md-icon-button",on:{"click":function($event){_vm.google(_vm.model)}}},[_c('img',{attrs:{"src":"/static/img/google.svg","alt":"G"}})])],1)],1),_vm._v(" "),_c('md-card-content',{staticClass:"description"},[_vm._v("\n     "+_vm._s(_vm.model.description)+"\n   ")]),_vm._v(" "),_c('md-card-actions',{staticClass:"actions"},[_c('md-button',{staticClass:"btn-next",on:{"click":function($event){_vm.previousModel()}}},[_vm._v("Back")]),_vm._v(" "),_c('md-button',{staticClass:"btn-next",on:{"click":function($event){_vm.nextModel()}}},[_vm._v("Next")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 354:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__ = __webpack_require__(132);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76015f7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__ = __webpack_require__(356);
function injectStyle (ssrContext) {
  __webpack_require__(355)
}
var normalizeComponent = __webpack_require__(46)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-76015f7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Form_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76015f7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Form_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 355:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 356:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":"https://formspree.io/pcopplestone@gmail.com","method":"POST"}},[_c('md-field',[_c('label',[_vm._v("Suggest an improved description")]),_vm._v(" "),_c('md-textarea',{model:{value:(_vm.suggestion),callback:function ($$v) {_vm.suggestion=$$v},expression:"suggestion"}})],1),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"category"},domProps:{"value":_vm.model.category}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"model"},domProps:{"value":_vm.model.name}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"suggestion"},domProps:{"value":_vm.suggestion}}),_vm._v(" "),_c('div',{staticClass:"right"},[_c('md-button',{staticClass:"btn-no-margin md-raised",attrs:{"type":"submit"}},[_vm._v("Send")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 357:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(133);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81bc6dba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(359);
function injectStyle (ssrContext) {
  __webpack_require__(358)
}
var normalizeComponent = __webpack_require__(46)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-81bc6dba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_81bc6dba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 358:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"action":"https://pollygot.us15.list-manage.com/subscribe/post?u=3c3e68a463cd5f23b2f8b59f5&id=10be3ff53e","method":"post","id":"subscribe-form","name":"subscribe-form","target":"_blank"}},[_c('div',{attrs:{"id":"mc_embed_signup_scroll"}},[_c('h4',[_vm._v("Sign up to receive one Mental Model to your inbox every day.")]),_vm._v(" "),_c('md-field',[(!_vm.email.length)?_c('label',[_vm._v("Email Address *")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.email),expression:"email"}],staticClass:"required email",attrs:{"type":"email","value":"","name":"EMAIL","id":"mce-EMAIL"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value}}})]),_vm._v(" "),_c('md-field',[(!_vm.first.length)?_c('label',[_vm._v("First Name *")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.first),expression:"first"}],attrs:{"type":"text","value":"","name":"FNAME","id":"mce-FNAME"},domProps:{"value":(_vm.first)},on:{"input":function($event){if($event.target.composing){ return; }_vm.first=$event.target.value}}})]),_vm._v(" "),_c('md-field',[(!_vm.last.length)?_c('label',[_vm._v("Last Name *")]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.last),expression:"last"}],attrs:{"type":"text","value":"","name":"LNAME","id":"mce-LNAME"},domProps:{"value":(_vm.last)},on:{"input":function($event){if($event.target.composing){ return; }_vm.last=$event.target.value}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"right"},[_c('md-button',{staticClass:"btn-no-margin md-raised",attrs:{"type":"submit","value":"Subscribe","name":"subscribe"}},[_vm._v("Subscribe")])],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"absolute","left":"-5000px"},attrs:{"aria-hidden":"true"}},[_c('input',{attrs:{"type":"text","name":"b_3c3e68a463cd5f23b2f8b59f5_10be3ff53e","tabindex":"-1","value":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout md-gutter md-alignment-center"},[_c('div',{staticClass:"md-layout-item md-size-50 md-small-size-100"},[(!_vm.shuffledModels.length)?_c('EmptyCard'):_vm._e(),_vm._v(" "),(_vm.shuffledModels.length)?_c('p',{staticClass:"md-caption"},[_vm._v(" "+_vm._s(_vm.cardIndex + 1)+" / "+_vm._s(_vm.shuffledModels.length))]):_vm._e(),_vm._v(" "),(_vm.shuffledModels.length)?_c('ModelCard',{attrs:{"model":_vm.currentModel},on:{"onNext":_vm.nextModel,"onPrevious":_vm.previousModel}}):_vm._e(),_vm._v(" "),_c('Signup')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logicalFallacies__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generalThinking__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__numeracy__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__systems__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__physicalWorld__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__biologicalWorld__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__humanNature__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__microeconomics__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__war__ = __webpack_require__(370);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }












__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var getters = {
  cardIndex: function cardIndex(state) {
    return state.cardIndex;
  },
  categoryList: function categoryList(state) {
    return [].concat(_toConsumableArray(new Set(state.models.map(function (item) {
      return item.category;
    }))));
  },
  modelList: function modelList(state) {
    return state.models;
  },
  selectedCategories: function selectedCategories(state) {
    return state.selectedCategories;
  }
};

var state = {
  cardIndex: 0,
  models: [].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__logicalFallacies__["a" /* default */].state.models), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_3__generalThinking__["a" /* default */].state.models), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_4__numeracy__["a" /* default */].state.models), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_5__systems__["a" /* default */].state.models), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_6__physicalWorld__["a" /* default */].state.models), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_7__biologicalWorld__["a" /* default */].state.models), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_8__humanNature__["a" /* default */].state.models), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_9__microeconomics__["a" /* default */].state.models), _toConsumableArray(__WEBPACK_IMPORTED_MODULE_10__war__["a" /* default */].state.models)),
  selectedCategories: ['Logical Fallacies', 'General Thinking Concepts', 'Numeracy', 'Systems', 'Physical World', 'The Biological World', 'Human Nature & Judgment', 'Microeconomics & Strategy', 'Military & War']
};

var mutations = {
  SET_CARD_INDEX: function SET_CARD_INDEX(state, payload) {
    state.cardIndex = payload;
  },
  SET_SELECTED_CATEGORIES: function SET_SELECTED_CATEGORIES(state, payload) {
    state.selectedCategories = payload;
  }
};

var actions = {};

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  models: [{
    name: 'Strawman',
    category: 'Logical Fallacies',
    description: '\nMisrepresenting someone\'s argument to make it easier to attack.\nBy exaggerating, misrepresenting, or just completely fabricating someone\'s argument, it\'s much easier to present your own position as being reasonable, but this kind of dishonesty serves to undermine honest rational debate.\n\nExample: After Will said that we should put more money into health and education, Warren responded by saying that he was surprised that Will hates our country so much that he wants to leave it defenceless by cutting military spending.\n'
  }, {
    name: 'False Cause',
    category: 'Logical Fallacies',
    description: '\nPresuming that a real or perceived relationship between things means that one is the cause of the other.\nMany people confuse correlation (things happening together or in sequence) for causation (that one thing actually causes the other to happen). Sometimes correlation is coincidental, or it may be attributable to a common cause.\n\nExample: Pointing to a fancy chart, Roger shows how temperatures have been rising over the past few centuries, whilst at the same time the numbers of pirates have been decreasing; thus pirates cool the world and global warming is a hoax.\n'
  }, {
    name: 'Appeal to Emotion',
    category: 'Logical Fallacies',
    description: '\nAttempting to manipulate an emotional response in place of a valid or compelling argument.\nAppeals to emotion include appeals to fear, envy, hatred, pity, pride, and more. It\'s important to note that sometimes a logically coherent argument may inspire emotion or have an emotional aspect, but the problem and fallacy occurs when emotion is used instead of a logical argument, or to obscure the fact that no compelling rational reason exists for one\'s position. Everyone, bar sociopaths, is affected by emotion, and so appeals to emotion are a very common and effective argument tactic, but they\'re ultimately flawed, dishonest, and tend to make one\'s opponents justifiably emotional.\n\nExample: Luke didn\'t want to eat his sheep\'s brains with chopped liver and brussel sprouts, but his father told him to think about the poor, starving children in a third world country who weren\'t fortunate enough to have any food at all.\n'
  }, {
    name: 'The Fallacy Fallacy',
    category: 'Logical Fallacies',
    description: '\nPresuming that because a claim has been poorly argued, or a fallacy has been made, that the claim itself must be wrong.\nIt is entirely possible to make a claim that is false yet argue with logical coherency for that claim, just as it is possible to make a claim that is true and justify it with various fallacies and poor arguments.\n\nExample: Recognising that Amanda had committed a fallacy in arguing that we should eat healthy food because a nutritionist said it was popular, Alyse said we should therefore eat bacon double cheeseburgers every day.\n'
  }, {
    name: 'Slippery Slope',
    category: 'Logical Fallacies',
    description: '\nSaying that if we allow A to happen, then Z will eventually happen too, therefore A should not happen.\nThe problem with this reasoning is that it avoids engaging with the issue at hand, and instead shifts attention to extreme hypotheticals. Because no proof is presented to show that such extreme hypotheticals will in fact occur, this fallacy has the form of an appeal to emotion fallacy by leveraging fear. In effect the argument at hand is unfairly tainted by unsubstantiated conjecture.\n\nExample: Colin Closet asserts that if we allow same-sex couples to marry, then the next thing we know we\'ll be allowing people to marry their parents, their cars and even monkeys.\n'
  }, {
    name: 'Ad Hominem',
    category: 'Logical Fallacies',
    description: '\nAttacking your opponent\'s character or personal traits in an attempt to undermine their argument.\nAd hominem attacks can take the form of overtly attacking somebody, or more subtly casting doubt on their character or personal attributes as a way to discredit their argument. The result of an ad hom attack can be to undermine someone\'s case without actually having to engage with it.\n\nExample: After Sally presents an eloquent and compelling case for a more equitable taxation system, Sam asks the audience whether we should believe anything from a woman who isn\'t married, was once arrested, and smells a bit weird.\n'
  }, {
    name: 'Tu Quoque',
    category: 'Logical Fallacies',
    description: '\nAvoiding having to engage with criticism by turning it back on the accuser - you answered criticism with criticism.\nPronounced too-kwo-kwee. Literally translating as \'you too\' this fallacy is also known as the appeal to hypocrisy. It is commonly employed as an effective red herring because it takes the heat off someone having to defend their argument, and instead shifts the focus back on to the person making the criticism.\n\nExample: Nicole identified that Hannah had committed a logical fallacy, but instead of addressing the substance of her claim, Hannah accused Nicole of committing a fallacy earlier on in the conversation.\n'
  }, {
    name: 'Personal Incredulity',
    category: 'Logical Fallacies',
    description: '\nBecause you found something difficult to understand, or are unaware of how it works, you make out like it\'s probably not true.\nComplex subjects like biological evolution through natural selection require some amount of understanding before one is able to make an informed judgement about the subject at hand; this fallacy is usually used in place of that understanding.\n\nExample: Kirk drew a picture of a fish and a human and with effusive disdain asked Richard if he really thought we were stupid enough to believe that a fish somehow turned into a human through just, like, random things happening over time.\n'
  }, {
    name: 'Special Pleading',
    category: 'Logical Fallacies',
    description: '\nMoving the goalposts or made up an exception when your claim was shown to be false.\nHumans are funny creatures and have a foolish aversion to being wrong. Rather than appreciate the benefits of being able to change one\'s mind through better understanding, many will invent ways to cling to old beliefs. One of the most common ways that people do this is to post-rationalize a reason why what they thought to be true must remain to be true. It\'s usually very easy to find a reason to believe something that suits us, and it requires integrity and genuine honesty with oneself to examine one\'s own beliefs and motivations without falling into the trap of justifying our existing ways of seeing ourselves and the world around us.\n\nExample: Edward Johns claimed to be psychic, but when his \'abilities\' were tested under proper scientific conditions, they magically disappeared. Edward explained this saying that one had to have faith in his abilities for them to work.\n'
  }, {
    name: 'Loaded Question',
    category: 'Logical Fallacies',
    description: '\nAsking a question that had a presumption built into it so that it couldn\'t be answered without appearing guilty.\nLoaded question fallacies are particularly effective at derailing rational debates because of their inflammatory nature - the recipient of the loaded question is compelled to defend themselves and may appear flustered or on the back foot.\n\nExample: Grace and Helen were both romantically interested in Brad. One day, with Brad sitting within earshot, Grace asked in an inquisitive tone whether Helen was still having problems with her drug habit.\n'
  }, {
    name: 'Burden of Proof',
    category: 'Logical Fallacies',
    description: '\nSaying that the burden of proof lies not with the person making the claim, but with someone else to disprove.\nThe burden of proof lies with someone who is making a claim, and is not upon anyone else to disprove. The inability, or disinclination, to disprove a claim does not render that claim valid, nor give it any credence whatsoever. However it is important to note that we can never be certain of anything, and so we must assign value to any claim based on the available evidence, and to dismiss something on the basis that it hasn\'t been proven beyond all doubt is also fallacious reasoning.\n\nExample: Bertrand declares that a teapot is, at this very moment, in orbit around the Sun between the Earth and Mars, and that because no one can prove him wrong, his claim is therefore a valid one.\n'
  }, {
    name: 'Ambiguity',
    category: 'Logical Fallacies',
    description: '\nUsing a double meaning or ambiguity of language to mislead or misrepresent the truth.\nPoliticians are often guilty of using ambiguity to mislead and will later point to how they were technically not outright lying if they come under scrutiny. The reason that it qualifies as a fallacy is that it is intrinsically misleading.\n\nExample: When the judge asked the defendant why he hadn\'t paid his parking fines, he said that he shouldn\'t have to pay them because the sign said \'Fine for parking here\' and so he naturally presumed that it would be fine to park there.\n'
  }, {
    name: 'The Gambler\'s Fallacy',
    category: 'Logical Fallacies',
    description: '\nSaying that \'runs\' occur to statistically independent phenomena such as roulette wheel spins.\nThis commonly believed fallacy can be said to have helped create an entire city in the desert of Nevada USA. Though the overall odds of a \'big run\' happening may be low, each spin of the wheel is itself entirely independent from the last. So whilst there may be a very small chance that heads will come up 20 times in a row if you flip a coin, the chances of heads coming up on each individual flip remain 50/50, and aren\'t influenced by what happened before.\n\nExample: Red had come up six times in a row on the roulette wheel, so Greg knew that it was close to certain that black would be next up. Suffering an economic form of natural selection with this thinking, he soon lost all of his savings.\n'
  }, {
    name: 'Bandwagon',
    category: 'Logical Fallacies',
    description: '\nAppealing to popularity or the fact that many people do something as an attempted form of validation.\nThe flaw in this argument is that the popularity of an idea has absolutely no bearing on its validity.\nIf it did, then the Earth would have made itself flat for most of history to accommodate this popular belief.\n\nExample: Shamus pointed a drunken finger at Sean and asked him to explain how so many people could believe in leprechauns if they\'re only a silly old superstition. Sean, however, had had a few too many Guinness himself and fell off his chair.\n'
  }, {
    name: 'Appeal to Authority',
    category: 'Logical Fallacies',
    description: '\nSaying that because an authority thinks something, it must therefore be true.\nIt\'s important to note that this fallacy should not be used to dismiss the claims of experts, or scientific consensus. Appeals to authority are not valid arguments, but nor is it reasonable to disregard the claims of experts who have a demonstrated depth of knowledge unless one has a similar level of understanding and/or access to empirical evidence. However, it is entirely possible that the opinion of a person or institution of authority is wrong; therefore the authority that such a person or institution holds does not have any intrinsic bearing upon whether their claims are true or not.\n\nExample: Not able to defend his position that evolution \'isn\'t true\' Bob says that he knows a scientist who also questions evolution (and presumably isn\'t a primate).\n'
  }, {
    name: 'Composition/Division',
    category: 'Logical Fallacies',
    description: '\nAssuming that one part of something has to be applied to all, or other, parts of it; or that the whole must apply to its parts.\nOften when something is true for the part it does also apply to the whole, or vice versa, but the crucial difference is whether there exists good evidence to show that this is the case. Because we observe consistencies in things, our thinking can become biased so that we presume consistency to exist where it does not.\n\nExample: Daniel was a precocious child and had a liking for logic. He reasoned that atoms are invisible, and that he was made of atoms and therefore invisible too. Unfortunately, despite his thinky skills, he lost the game of hide and go seek.\n'
  }, {
    name: 'No True Scotsman',
    category: 'Logical Fallacies',
    description: '\nMaking what could be called an appeal to purity as a way to dismiss relevant criticisms or flaws of your argument.\nIn this form of faulty reasoning one\'s belief is rendered unfalsifiable because no matter how compelling the evidence is, one simply shifts the goalposts so that it wouldn\'t apply to a supposedly \'true\' example. This kind of post-rationalization is a way of avoiding valid criticisms of one\'s argument.\n\nExample: Angus declares that Scotsmen do not put sugar on their porridge, to which Lachlan points out that he is a Scotsman and puts sugar on his porridge. Furious, like a true Scot, Angus yells that no true Scotsman sugars his porridge.\n'
  }, {
    name: 'Genetic',
    category: 'Logical Fallacies',
    description: '\nJudging something as either good or bad on the basis of where it comes from, or from whom it came.\nThis fallacy avoids the argument by shifting focus onto something\'s or someone\'s origins. It\'s similar to an ad hominem fallacy in that it leverages existing negative perceptions to make someone\'s argument look bad, without actually presenting a case for why the argument itself lacks merit.\n\nExample: Accused on the 6 o\'clock news of corruption and taking bribes, the senator said that we should all be very wary of the things we hear in the media, because we all know how very unreliable the media can be.\n'
  }, {
    name: 'Black-or-White',
    category: 'Logical Fallacies',
    description: '\nPresenting two alternative states as the only possibilities, when in fact more possibilities exist.\nAlso known as the false dilemma, this insidious tactic has the appearance of forming a logical argument, but under closer scrutiny it becomes evident that there are more possibilities than the either/or choice that is presented. Binary, black-or-white thinking doesn\'t allow for the many different variables, conditions, and contexts in which there would exist more than just the two possibilities put forth. It frames the argument misleadingly and obscures rational, honest debate.\n\nExample: Whilst rallying support for his plan to fundamentally undermine citizens\' rights, the Supreme Leader told the people they were either on his side, or they were on the side of the enemy.\n'
  }, {
    name: 'Begging the Question',
    category: 'Logical Fallacies',
    description: '\nPresenting a circular argument in which the conclusion was included in the premise.\nThis logically incoherent argument often arises in situations where people have an assumption that is very ingrained, and therefore taken in their minds as a given. Circular reasoning is bad mostly because it\'s not very good.\n\nExample: The word of Zorbo the Great is flawless and perfect. We know this because it says so in The Great and Infallible Book of Zorbo\'s Best and Most Truest Things that are Definitely True and Should Not Ever Be Questioned.\n'
  }, {
    name: 'Appeal to Nature',
    category: 'Logical Fallacies',
    description: '\nArguing that because something is \'natural\' it is therefore valid, justified, inevitable, good or ideal.\nMany \'natural\' things are also considered \'good\', and this can bias our thinking; but naturalness itself doesn\'t make something good or bad. For instance murder could be seen as very natural, but that doesn\'t mean it\'s good or justifiable.\n\nExample: The medicine man rolled into town on his bandwagon offering various natural remedies, such as very special plain water. He said that it was only natural that people should be wary of \'artificial\' medicines such as antibiotics.\n'
  }, {
    name: 'Anecdotal',
    category: 'Logical Fallacies',
    description: '\nUsing a personal experience or an isolated example instead of a sound argument or compelling evidence.\nIt\'s often much easier for people to believe someone\'s testimony as opposed to understanding complex data and variation across a continuum. Quantitative scientific measures are almost always more accurate than personal perceptions and experiences, but our inclination is to believe that which is tangible to us, and/or the word of someone we trust over a more \'abstract\' statistical reality.\n\nExample: Jason said that that was all cool and everything, but his grandfather smoked, like, 30 cigarettes a day and lived until 97 - so don\'t believe everything you read about meta analyses of methodologically sound studies showing proven causal relationships.\n'
  }, {
    name: 'The Texas Sharpshooter',
    category: 'Logical Fallacies',
    description: '\nCherry-picking a data cluster to suit your argument, or found a pattern to fit a presumption.\nThis \'false cause\' fallacy is coined after a marksman shooting randomly at barns and then painting bullseye targets around the spot where the most bullet holes appear, making it appear as if he\'s a really good shot. Clusters naturally appear by chance, but don\'t necessarily indicate that there is a causal relationship.\n\nExample: The makers of Sugarette Candy Drinks point to research showing that of the five countries where Sugarette drinks sell the most units, three of them are in the top ten healthiest countries on Earth, therefore Sugarette drinks are healthy.\n'
  }, {
    name: 'Middle Ground',
    category: 'Logical Fallacies',
    description: '\nCliming that a compromise, or middle point, between two extremes must be the truth.\nMuch of the time the truth does indeed lie between two extreme points, but this can bias our thinking: sometimes a thing is simply untrue and a compromise of it is also untrue. Half way between truth and a lie, is still a lie.\n\nExample: Holly said that vaccinations caused autism in children, but her scientifically well-read friend Caleb said that this claim had been debunked and proven false. Their friend Alice offered a compromise that vaccinations must cause some autism, just not all autism.\n'
  }]
};

var logicalFallacies = {
  state: state
};
/* harmony default export */ __webpack_exports__["a"] = (logicalFallacies);

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  models: [{
    name: 'Inversion',
    category: 'General Thinking Concepts',
    description: '\nOtherwise known as thinking through a situation in reverse or thinking \u201Cbackwards,\u201D inversion is a problem-solving technique. Often by considering what we want to avoid rather than what we want to get, we come up with better solutions. Inversion works not just in mathematics but in nearly every area of life. As the saying goes, \u201CJust tell me where I\u2019m going to die so I can never go there.\u201D\n'
  }, {
    name: 'Falsification / Confirmation Bias',
    category: 'General Thinking Concepts',
    description: '\nWhat a man wishes, he also believes. Similarly, what we believe is what we choose to see. This is commonly referred to as the confirmation bias. It is a deeply ingrained mental habit, both energy-conserving and comfortable, to look for confirmations of long-held wisdom rather than violations. Yet the scientific process \u2013 including hypothesis generation, blind testing when needed, and objective statistical rigor \u2013 is designed to root out precisely the opposite, which is why it works so well when followed.\n\nThe modern scientific enterprise operates under the principle of falsification: A method is termed scientific if it can be stated in such a way that a certain defined result would cause it to be proved false. Pseudo-knowledge and pseudo-science operate and propagate by being unfalsifiable \u2013 as with astrology, we are unable to prove them either correct or incorrect because the conditions under which they would be shown false are never stated.\n'
  }, {
    name: 'Circle of Competence',
    category: 'General Thinking Concepts',
    description: '\nAn idea introduced by Warren Buffett and Charles Munger in relation to investing: each individual tends to have an area or areas in which they really, truly know their stuff, their area of special competence. Areas not inside that circle are problematic because not only are we ignorant about them, but we may also be ignorant of our own ignorance. Thus, when we\'re making decisions, it becomes important to define and attend to our special circle, so as to act accordingly.\n'
  }, {
    name: 'The Principle of Parsimony (Occam\'s Razor)',
    category: 'General Thinking Concepts',
    description: '\nNamed after the friar William of Ockham, Occam\u2019s Razor is a heuristic by which we select among competing explanations. Ockham stated that we should prefer the simplest explanation with the least moving parts: it is easier to falsify (see: Falsification), easier to understand, and more likely, on average, to be correct. This principle is not an iron law but a tendency and a mindset: If all else is equal, it\u2019s more likely that the simple solution suffices. Of course, we also keep in mind Einstein\u2019s famous idea (even if apocryphal) that \u201Can idea should be made as simple as possible, but no simpler.\u201D\n'
  }, {
    name: 'Hanlon\'s Razor',
    category: 'General Thinking Concepts',
    description: '\nHarder to trace in its origin, Hanlon\u2019s Razor states that we should not attribute to malice that which is more easily explained by stupidity. In a complex world, this principle helps us avoid extreme paranoia and ideology, often very hard to escape from, by not generally assuming that bad results are the fault of a bad actor, although they can be. More likely, a mistake has been made.\n'
  }, {
    name: 'Second-Order Thinking',
    category: 'General Thinking Concepts',
    description: '\nIn all human systems and most complex systems, the second layer of effects often dwarfs the first layer, yet often goes unconsidered. In other words, we must consider that effects have effects. Second-order thinking is best illustrated by the idea of standing on your tiptoes at a parade: Once one person does it, everyone will do it in order to see, thus negating the first tiptoer. Now, however, the whole parade audience suffers on their toes rather than standing firmly on their whole feet.\n'
  }, {
    name: 'The Map Is Not the Territory',
    category: 'General Thinking Concepts',
    description: '\nThe map of reality is not reality itself. If any map were to represent its actual territory with perfect fidelity, it would be the size of the territory itself. Thus, no need for a map! This model tells us that there will always be an imperfect relationship between reality and the models we use to represent and understand it. This imperfection is a necessity in order to simplify. It is all we can do to accept this and act accordingly.\n'
  }, {
    name: 'Thought Experiments',
    category: 'General Thinking Concepts',
    description: '\nA technique popularized by Einstein, the thought experiment is a way to logically carry out a test in one\u2019s own head that would be very difficult or impossible to perform in real life. With the thought experiment as a tool, we can solve problems with intuition and logic that could not be demonstrated physically, as with Einstein imagining himself traveling on a beam of light in order to solve the problem of relativity.\n'
  }, {
    name: 'Mr. Market',
    category: 'General Thinking Concepts',
    description: '\nMr. Market was introduced by the investor Benjamin Graham in his seminal book The Intelligent Investor to represent the vicissitudes of the financial markets. As Graham explains, the markets are a bit like a moody neighbor, sometimes waking up happy and sometimes waking up sad \u2013 your job as an investor is to take advantage of him in his bad moods and sell to him in his good moods. This attitude is contrasted to an efficient-market hypothesis in which Mr. Market always wakes up in the middle of the bed, never feeling overly strong in either direction.\n'
  }, {
    name: 'Probabilistic Thinking (See also: Numeracy/Bayesian Updating)',
    category: 'General Thinking Concepts',
    description: '\nThe unknowable human world is dominated by probabilistic outcomes, as distinguished from deterministic ones. Although we cannot predict the future with great certainty, we are wise to ascribe odds to more and less probable events. We do this every day unconsciously as we cross the street and ascribe low, yet not negligible, odds of being hit by a car.\n'
  }, {
    name: 'Default Status',
    category: 'General Thinking Concepts',
    description: '\nThe USCB ecologist/economist Garrett Hardin once said that \u201CThe scientific mind is not closed: it is merely well-guarded by a conscientious and seldom sleeping gatekeeper.\u201D The way it does that is with the concept of the default status: The \u201Cresting position\u201D of common sense, whereby the burden of proof falls on assertions to the contrary. Given the problem of opportunity costs and limited time and energy, a default status is nearly always necessary to avoid wasting time. Examples include the laws of thermodynamics, the law of natural selection, and the incentive-caused bias.\n'
  }]
};

var generalThinking = {
  state: state
};
/* harmony default export */ __webpack_exports__["a"] = (generalThinking);

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  models: [{
    name: 'Permutations and Combinations',
    category: 'Numeracy',
    description: '\nThe mathematics of permutations and combinations leads us to understand the practical probabilities of the world around us, how things can be ordered, and how we should think about things.\n'
  }, {
    name: 'Algebraic Equivalence',
    category: 'Numeracy',
    description: '\nThe introduction of algebra allowed us to demonstrate mathematically and abstractly that two seemingly different things could be the same. By manipulating symbols, we can demonstrate equivalence or inequivalence, the use of which led humanity to untold engineering and technical abilities. Knowing at least the basics of algebra can allow us to understand a variety of important results.\n'
  }, {
    name: 'Randomness',
    category: 'Numeracy',
    description: '\nThough the human brain has trouble comprehending it, much of the world is composed of random, non-sequential, non-ordered events. We are \u201Cfooled\u201D by random effects when we attribute causality to things that are actually outside of our control. If we don\u2019t course-correct for this fooled-by-randomness effect \u2013 our faulty sense of pattern-seeking \u2013 we will tend to see things as being more predictable than they are and act accordingly.\n'
  }, {
    name: 'Stochastic Processes (Poisson, Markov, Random Walk)',
    category: 'Numeracy',
    description: '\nA stochastic process is a random statistical process and encompasses a wide variety of processes in which the movement of an individual variable can be impossible to predict but can be thought through probabilistically. The wide variety of stochastic methods helps us describe systems of variables through probabilities without necessarily being able to determine the position of any individual variable over time. For example, it\u2019s not possible to predict stock prices on a day-to-day basis, but we can describe the probability of various distributions of their movements over time. Obviously, it is much more likely that the stock market (a stochastic process) will be up or down 1% in a day than up or down 10%, even though we can\u2019t predict what tomorrow will bring.\n'
  }, {
    name: 'Compounding',
    category: 'Numeracy',
    description: '\nIt\u2019s been said that Einstein called compounding a wonder of the world. He probably didn\u2019t, but it is a wonder. Compounding is the process by which we add interest to a fixed sum, which then earns interest on the previous sum and the newly added interest, and then earns interest on that amount, and so on ad infinitum. It is an exponential effect, rather than a linear, or additive, effect. Money is not the only thing that compounds; ideas and relationships do as well. In tangible realms, compounding is always subject to physical limits and diminishing returns; intangibles can compound more freely. Compounding also leads to the time value of money, which underlies all of modern finance.\n'
  }, {
    name: 'Multiplying by Zero',
    category: 'Numeracy',
    description: '\nAny reasonably educated person knows that any number multiplied by zero, no matter how large the number, is still zero. This is true in human systems as well as mathematical ones. In some systems, a failure in one area can negate great effort in all other areas. As simple multiplication would show, fixing the \u201Czero\u201D often has a much greater effect than does trying to enlarge the other areas.\n'
  }, {
    name: 'Churn',
    category: 'Numeracy',
    description: '\nInsurance companies and subscription services are well aware of the concept of churn \u2013 every year, a certain number of customers are lost and must be replaced. Standing still is the equivalent of losing, as seen in the model called the \u201CRed Queen Effect.\u201D Churn is present in many business and human systems: A constant figure is periodically lost and must be replaced before any new figures are added over the top.\n'
  }, {
    name: 'Law of Large Numbers',
    category: 'Numeracy',
    description: '\nOne of the fundamental underlying assumptions of probability is that as more instances of an event occur, the actual results will converge on the expected ones. For example, if I know that the average man is 5 feet 10 inches tall, I am far more likely to get an average of 5\u203210\u2033 by selecting 500 men at random than 5 men at random. The opposite of this model is the law of small numbers, which states that small samples can and should be looked at with great skepticism.\n'
  }, {
    name: 'Bell Curve/Normal Distribution',
    category: 'Numeracy',
    description: '\nThe normal distribution is a statistical process that leads to the well-known graphical representation of a bell curve, with a meaningful central \u201Caverage\u201D and increasingly rare standard deviations from that average when correctly sampled. (The so-called \u201Ccentral limit\u201D theorem.) Well-known examples include human height and weight, but it\u2019s just as important to note that many common processes, especially in non-tangible systems like social systems, do not follow the normal distribution.\n'
  }, {
    name: 'Power Laws',
    category: 'Numeracy',
    description: '\nOne of the most common processes that does not fit the normal distribution is that of a power law, whereby one quantity varies with another\u2019s exponent rather than linearly. For example, the Richter scale describes the power of earthquakes on a power-law distribution scale: an 8 is 10x more destructive than a 7, and a 9 is 10x more destructive than an 8. The central limit theorem does not apply and there is thus no \u201Caverage\u201D earthquake. This is true of all power-law distributions.\n'
  }, {
    name: 'Fat-Tailed Processes (Extremistan)',
    category: 'Numeracy',
    description: '\nA process can often look like a normal distribution but have a large \u201Ctail\u201D \u2013 meaning that seemingly outlier events are far more likely than they are in an actual normal distribution. A strategy or process may be far more risky than a normal distribution is capable of describing if the fat tail is on the negative side, or far more profitable if the fat tail is on the positive side. Much of the human social world is said to be fat-tailed rather than normally distributed.\n'
  }, {
    name: 'Bayesian Updating',
    category: 'Numeracy',
    description: '\nThe Bayesian method is a method of thought (named for Thomas Bayes) whereby one takes into account all prior relevant probabilities and then incrementally updates them as newer information arrives. This method is especially productive given the fundamentally non-deterministic world we experience: We must use prior odds and new information in combination to arrive at our best decisions. This is not necessarily our intuitive decision-making engine.\n'
  }, {
    name: 'Regression to the Mean',
    category: 'Numeracy',
    description: '\nIn a normally distributed system, long deviations from the average will tend to return to that average with an increasing number of observations: the so-called Law of Large Numbers. We are often fooled by regression to the mean, as with a sick patient improving spontaneously around the same time they begin taking an herbal remedy, or a poorly performing sports team going on a winning streak. We must be careful not to confuse statistically likely events with causal ones.\n'
  }, {
    name: 'Order of Magnitude',
    category: 'Numeracy',
    description: '\nIn many, perhaps most, systems, quantitative description down to a precise figure is either impossible or useless (or both). For example, estimating the distance between our galaxy and the next one over is a matter of knowing not the precise number of miles, but how many zeroes are after the 1. Is the distance about 1 million miles or about 1 billion? This thought habit can help us escape useless precision.\n'
  }]
};

var numeracy = {
  state: state
};
/* harmony default export */ __webpack_exports__["a"] = (numeracy);

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  models: [{
    name: 'Scale',
    category: 'Systems',
    description: '\nOne of the most important principles of systems is that they are sensitive to scale. Properties (or behaviors) tend to change when you scale them up or down. In studying complex systems, we must always be roughly quantifying \u2013 in orders of magnitude, at least \u2013 the scale at which we are observing, analyzing, or predicting the system.\n'
  }, {
    name: 'Law of Diminishing Returns',
    category: 'Systems',
    description: '\nRelated to scale, most important real-world results are subject to an eventual decrease of incremental value. A good example would be a poor family: Give them enough money to thrive, and they are no longer poor. But after a certain point, additional money will not improve their lot; there is a clear diminishing return of additional dollars at some roughly quantifiable point. Often, the law of diminishing returns veers into negative territory \u2013 i.e., receiving too much money could destroy the poor family.\n'
  }, {
    name: 'Pareto Principle',
    category: 'Systems',
    description: '\nNamed for Italian polymath Vilfredo Pareto, who noticed that 80% of Italy\u2019s land was owned by about 20% of its population, the Pareto Principle states that a small amount of some phenomenon causes a disproportionately large effect. The Pareto Principle is an example of a power-law type of statistical distribution \u2013 as distinguished from a traditional bell curve \u2013 and is demonstrated in various phenomena ranging from wealth to city populations to important human habits.\n'
  }, {
    name: 'Feedback Loops (and Homeostasis)',
    category: 'Systems',
    description: '\nAll complex systems are subject to positive and negative feedback loops whereby A causes B, which in turn influences A (and C), and so on \u2013 with higher-order effects frequently resulting from continual movement of the loop. In a homeostatic system, a change in A is often brought back into line by an opposite change in B to maintain the balance of the system, as with the temperature of the human body or the behavior of an organizational culture. Automatic feedback loops maintain a \u201Cstatic\u201D environment unless and until an outside force changes the loop. A \u201Crunaway feedback loop\u201D describes a situation in which the output of a reaction becomes its own catalyst (auto-catalysis).\n'
  }, {
    name: 'Chaos Dynamics (Sensitivity to Initial Conditions)',
    category: 'Systems',
    description: '\nIn a world such as ours, governed by chaos dynamics, small changes (perturbations) in initial conditions have massive downstream effects as near-infinite feedback loops occur; this phenomenon is also called the butterfly effect. This means that some aspects of physical systems (like the weather more than a few days from now) as well as social systems (the behavior of a group of human beings over a long period) are fundamentally unpredictable.\n'
  }, {
    name: 'Preferential Attachment (Cumulative Advantage)',
    category: 'Systems',
    description: '\nA preferential attachment situation occurs when the current leader is given more of the reward than the laggards, thereby tending to preserve or enhance the status of the leader. A strong network effect is a good example of preferential attachment; a market with 10x more buyers and sellers than the next largest market will tend to have a preferential attachment dynamic.\n'
  }, {
    name: 'Emergence',
    category: 'Systems',
    description: '\nHigher-level behavior tends to emerge from the interaction of lower-order components. The result is frequently not linear \u2013 not a matter of simple addition \u2013 but rather non-linear, or exponential. An important resulting property of emergent behavior is that it cannot be predicted from simply studying the component parts.\n'
  }, {
    name: 'Irreducibility',
    category: 'Systems',
    description: '\nWe find that in most systems there are irreducible quantitative properties, such as complexity, minimums, time, and length. Below the irreducible level, the desired result simply does not occur. One cannot get several women pregnant to reduce the amount of time needed to have one child, and one cannot reduce a successfully built automobile to a single part. These results are, to a defined point, irreducible.\n'
  }, {
    name: 'Tragedy of the Commons',
    category: 'Systems',
    description: '\nA concept introduced by the economist and ecologist Garrett Hardin, the Tragedy of the Commons states that in a system where a common resource is shared, with no individual responsible for the wellbeing of the resource, it will tend to be depleted over time. The Tragedy is reducible to incentives: Unless people collaborate, each individual derives more personal benefit than the cost that he or she incurs, and therefore depletes the resource for fear of missing out.\n'
  }, {
    name: 'Gresham\u2019s Law',
    category: 'Systems',
    description: '\nGresham\u2019s Law, named for the financier Thomas Gresham, states that in a system of circulating currency, forged currency will tend to drive out real currency, as real currency is hoarded and forged currency is spent. We see a similar result in human systems, as with bad behavior driving out good behavior in a crumbling moral system, or bad practices driving out good practices in a crumbling economic system. Generally, regulation and oversight are required to prevent results that follow Gresham\u2019s Law.\n'
  }, {
    name: 'Algorithms',
    category: 'Systems',
    description: '\nWhile hard to precisely define, an algorithm is generally an automated set of rules or a \u201Cblueprint\u201D leading a series of steps or actions resulting in a desired outcome, and often stated in the form of a series of \u201CIf \u2192 Then\u201D statements. Algorithms are best known for their use in modern computing, but are a feature of biological life as well. For example, human DNA contains an algorithm for building a human being.\n'
  }, {
    name: 'Fragility \u2013 Robustness \u2013 Antifragility',
    category: 'Systems',
    description: '\nPopularized by Nassim Taleb, the sliding scale of fragility, robustness, and antifragility refers to the responsiveness of a system to incremental negative variability. A fragile system or object is one in which additional negative variability has a disproportionately negative impact, as with a coffee cup shattering from a 6-foot fall, but receiving no damage at all (rather than 1/6th of the damage) from a 1-foot fall. A robust system or object tends to be neutral to the additional negativity variability, and of course, an antifragile system benefits: If there were a cup that got stronger when dropped from 6 feet than when dropped from 1 foot, it would be termed antifragile.\n'
  }, {
    name: 'Backup Systems/Redundancy',
    category: 'Systems',
    description: '\nA critical model of the engineering profession is that of backup systems. A good engineer never assumes the perfect reliability of the components of the system. He or she builds in redundancy to protect the integrity of the total system. Without the application of this robustness principle, tangible and intangible systems tend to fail over time.\n'
  }, {
    name: 'Margin of Safety',
    category: 'Systems',
    description: '\nSimilarly, engineers have also developed the habit of adding a margin for error into all calculations. In an unknown world, driving a 9,500-pound bus over a bridge built to hold precisely 9,600 pounds is rarely seen as intelligent. Thus, on the whole, few modern bridges ever fail. In practical life outside of physical engineering, we can often profitably give ourselves margins as robust as the bridge system.\n'
  }, {
    name: 'Criticality',
    category: 'Systems',
    description: '\nA system becomes critical when it is about to jump discretely from one phase to another. The marginal utility of the last unit before the phase change is wildly higher than any unit before it. A frequently cited example is water turning from a liquid to a vapor when heated to a specific temperature. \u201CCritical mass\u201D refers to the mass needed to have the critical event occur, most commonly in a nuclear system.\n'
  }, {
    name: 'Network Effects',
    category: 'Systems',
    description: '\nA network tends to become more valuable as nodes are added to the network: this is known as the network effect. An easy example is contrasting the development of the electricity system and the telephone system. If only one house has electricity, its inhabitants have gained immense value, but if only one house has a telephone, its inhabitants have gained nothing of use. Only with additional telephones does the phone network gain value. This network effect is widespread in the modern world and creates immense value for organizations and customers alike.\n'
  }, {
    name: 'Black Swan',
    category: 'Systems',
    description: '\nAlso popularized by Nassim Taleb, a Black Swan is a rare and highly consequential event that is invisible to a given observer ahead of time. It is a result of applied epistemology: If you have seen only white swans, you cannot categorically state that there are no black swans, but the inverse is not true: seeing one black swan is enough for you to state that there are black swans. Black Swan events are necessarily unpredictable to the observer (as Taleb likes to say, Thanksgiving is a Black Swan for the turkey, not the butcher) and thus must be dealt with by addressing the fragility-robustness-antifragility spectrum rather than through better methods of prediction.\n'
  }, {
    name: 'Via Negativa \u2013 Omission / Removal / Avoidance of Harm',
    category: 'Systems',
    description: '\nIn many systems, improvement is at best, or at times only, a result of removing bad elements rather than of adding good elements. This is a credo built into the modern medical profession: First, do no harm. Similarly, if one has a group of children behaving badly, removal of the instigator is often much more effective than any form of punishment meted out to the whole group.\n'
  }, {
    name: 'The Lindy Effect',
    category: 'Systems',
    description: '\nThe Lindy Effect refers to the life expectancy of a non-perishable object or idea being related to its current lifespan. If an idea or object has lasted for X number of years, it would be expected (on average) to last another X years. Although a human being who is 90 and lives to 95 does not add 5 years to his or her life expectancy, non-perishables lengthen their life expectancy as they continually survive. A classic text is a prime example: if humanity has been reading Shakespeare\u2019s plays for 500 years, it will be expected to read them for another 500.\n'
  }, {
    name: 'Renormalization Group',
    category: 'Systems',
    description: '\nThe renormalization group technique allows us to think about physical and social systems at different scales. An idea from physics, and a complicated one at that, the application of a renormalization group to social systems allows us to understand why a small number of stubborn individuals can have a disproportionate impact if those around them follow suit on increasingly large scales.\n'
  }, {
    name: 'Spring-loading',
    category: 'Systems',
    description: '\nA system is spring-loaded if it is coiled in a certain direction, positive or negative. Positively spring-loading systems and relationships is important in a fundamentally unpredictable world to help protect us against negative events. The reverse can be very destructive.\n'
  }, {
    name: 'Complex Adaptive Systems',
    category: 'Systems',
    description: '\nA complex adaptive system, as distinguished from a complex system in general, is one that can understand itself and change based on that understanding. Complex adaptive systems are social systems. The difference is best illustrated by thinking about weather prediction contrasted to stock market prediction. The weather will not change based on an important forecaster\u2019s opinion, but the stock market might. Complex adaptive systems are thus fundamentally not predictable.\n'
  }]
};

var systems = {
  state: state
};
/* harmony default export */ __webpack_exports__["a"] = (systems);

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  models: [{
    name: 'Laws of Thermodynamics',
    category: 'Physical World',
    description: '\nThe laws of thermodynamics describe energy in a closed system. The laws cannot be escaped and underlie the physical world. They describe a world in which useful energy is constantly being lost, and energy cannot be created or destroyed. Applying their lessons to the social world can be a profitable enterprise.\n'
  }, {
    name: 'Reciprocity',
    category: 'Physical World',
    description: '\nIf I push on a wall, physics tells me that the wall pushes back with equivalent force. In a biological system, if one individual acts on another, the action will tend to be reciprocated in kind. And of course, human beings act with intense reciprocity demonstrated as well.\n'
  }, {
    name: 'Velocity',
    category: 'Physical World',
    description: '\nVelocity is not equivalent to speed; the two are sometimes confused. Velocity is speed plus vector: how fast something gets somewhere. An object that moves two steps forward and then two steps back has moved at a certain speed but shows no velocity. The addition of the vector, that critical distinction, is what we should consider in practical life.\n'
  }, {
    name: 'Relativity',
    category: 'Physical World',
    description: '\nRelativity has been used in several contexts in the world of physics, but the important aspect to study is the idea that an observer cannot truly understand a system of which he himself is a part. For example, a man inside an airplane does not feel like he is experiencing movement, but an outside observer can see that movement is occurring. This form of relativity tends to affect social systems in a similar way.\n'
  }, {
    name: 'Activation Energy',
    category: 'Physical World',
    description: '\nA fire is not much more than a combination of carbon and oxygen, but the forests and coal mines of the world are not combusting at will because such a chemical reaction requires the input of a critical level of \u201Cactivation energy\u201D in order to get a reaction started. Two combustible elements alone are not enough.\n'
  }, {
    name: 'Catalysts',
    category: 'Physical World',
    description: '\nA catalyst either kick-starts or maintains a chemical reaction, but isn\u2019t itself a reactant. The reaction may slow or stop without the addition of catalysts. Social systems, of course, take on many similar traits, and we can view catalysts in a similar light.\n'
  }, {
    name: 'Leverage',
    category: 'Physical World',
    description: '\nMost of the engineering marvels of the world have been accomplished with applied leverage. As famously stated by Archimedes, \u201CGive me a lever long enough and I shall move the world.\u201D With a small amount of input force, we can make a great output force through leverage. Understanding where we can apply this model to the human world can be a source of great success.\n'
  }, {
    name: 'Inertia',
    category: 'Physical World',
    description: '\nAn object in motion with a certain vector wants to continue moving in that direction unless acted upon. This is a fundamental physical principle of motion; however, individuals, systems, and organizations display the same effect. It allows them to minimize the use of energy, but can cause them to be destroyed or eroded.\n'
  }, {
    name: 'Alloying',
    category: 'Physical World',
    description: '\nWhen we combine various elements, we create new substances. This is no great surprise, but what can be surprising in the alloying process is that 2+2 can equal not 4 but 6 \u2013 the alloy can be far stronger than the simple addition of the underlying elements would lead us to believe. This process leads us to engineering great physical objects, but we understand many intangibles in the same way; a combination of the right elements in social systems or even individuals can create a 2+2=6 effect similar to alloying.\n'
  }]
};

var physicalWorld = {
  state: state
};
/* harmony default export */ __webpack_exports__["a"] = (physicalWorld);

/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  models: [{
    name: 'Incentives',
    category: 'The Biological World',
    description: '\nAll creatures respond to incentives to keep themselves alive. This is the basic insight of biology. Constant incentives will tend to cause a biological entity to have constant behavior, to an extent. Humans are included and are particularly great examples of the incentive-driven nature of biology; however, humans are complicated in that their incentives can be hidden or intangible. The rule of life is to repeat what works and has been rewarded.\n'
  }, {
    name: 'Cooperation (Including Symbiosis)',
    category: 'The Biological World',
    description: '\nCompetition tends to describe most biological systems, but cooperation at various levels is just as important a dynamic. In fact, the cooperation of a bacterium and a simple cell probably created the first complex cell and all of the life we see around us. Without cooperation, no group survives, and the cooperation of groups gives rise to even more complex versions of organization. Cooperation and competition tend to coexist at multiple levels.\n'
  }, {
    name: 'Tendency to Minimize Energy Output (Mental & Physical)',
    category: 'The Biological World',
    description: '\nIn a physical world governed by thermodynamics and competition for limited energy and resources, any biological organism that was wasteful with energy would be at a severe disadvantage for survival. Thus, we see in most instances that behavior is governed by a tendency to minimize energy usage when at all possible.\n'
  }, {
    name: 'Adaptation',
    category: 'The Biological World',
    description: '\nSpecies tend to adapt to their surroundings in order to survive, given the combination of their genetics and their environment \u2013 an always-unavoidable combination. However, adaptations made in an individual\'s lifetime are not passed down genetically, as was once thought: Populations of species adapt through the process of evolution by natural selection, as the most-fit examples of the species replicate at an above-average rate.\n'
  }, {
    name: 'Evolution by Natural Selection',
    category: 'The Biological World',
    description: '\nEvolution by natural selection was once called \u201Cthe greatest idea anyone ever had.\u201D In the 19th century, Charles Darwin and Alfred Russel Wallace simultaneous realized that species evolve through random mutation and differential survival rates. If we call human intervention in animal-breeding an example of \u201Cartificial selection,\u201D we can call Mother Nature deciding the success or failure of a particular mutation \u201Cnatural selection.\u201D Those best suited for survival tend to be preserved. But of course, conditions change.\n'
  }, {
    name: 'The Red Queen Effect (Co-evolutionary Arms Race)',
    category: 'The Biological World',
    description: '\nThe evolution-by-natural-selection model leads to something of an arms race among species competing for limited resources. When one species evolves an advantageous adaptation, a competing species must respond in kind or fail as a species. Standing pat can mean falling behind. This arms race is called the Red Queen Effect for the character in Alice in Wonderland who said, \u201CNow, here, you see, it takes all the running you can do, to keep in the same place.\u201D\n'
  }, {
    name: 'Replication',
    category: 'The Biological World',
    description: '\nA fundamental building block of diverse biological life is high-fidelity replication. The fundamental unit of replication seems to be the DNA molecule, which provides a blueprint for the offspring to be built from physical building blocks. There are a variety of replication methods, but most can be lumped into sexual and asexual.\n'
  }, {
    name: 'Hierarchical and Other Organizing Instincts',
    category: 'The Biological World',
    description: '\nMost complex biological organisms have an innate feel for how they should organize. While not all of them end up in hierarchical structures, many do, especially in the animal kingdom. Human beings like to think they are outside of this, but they feel the hierarchical instinct as strongly as any other organism.\n'
  }, {
    name: 'Self-Preservation Instincts',
    category: 'The Biological World',
    description: '\nWithout a strong self-preservation instinct in an organism\u2019s DNA, it would tend to disappear over time, thus eliminating that DNA. While cooperation is another important model, the self-preservation instinct is strong in all organisms and can cause violent, erratic, and/or destructive behavior for those around them.\n'
  }, {
    name: 'Simple Physiological Reward-Seeking',
    category: 'The Biological World',
    description: '\nAll organisms feel pleasure and pain from simple chemical processes in their bodies which respond predictably to the outside world. Reward-seeking is an effective survival-promoting technique on average. However, those same pleasure receptors can be co-opted to cause destructive behavior, as with drug abuse.\n'
  }, {
    name: 'Exaptation',
    category: 'The Biological World',
    description: '\nIntroduced by the biologist Steven Jay Gould, an exaptation refers to a trait developed for one purpose that is later used for another purpose. This is one way to explain the development of complex biological features like an eyeball; in a more primitive form, it may have been used for something else. Once it was there, and once it developed further, 3D sight became possible.\n'
  }, {
    name: 'Extinction',
    category: 'The Biological World',
    description: '\nThe inability to survive can cause an extinction event, whereby an entire species ceases to compete and replicate effectively. Once its numbers have dwindled to a critically low level, an extinction can be unavoidable (and predictable) given the inability to effectively replicate in large enough numbers.\n'
  }, {
    name: 'Ecosystems',
    category: 'The Biological World',
    description: '\nAn ecosystem describes any group of organisms coexisting with the natural world. Most ecosystems show diverse forms of life taking on different approaches to survival, with such pressures leading to varying behavior. Social systems can be seen in the same light as the physical ecosystems and many of the same conclusions can be made.\n'
  }, {
    name: 'Niches',
    category: 'The Biological World',
    description: '\nMost organisms find a niche: a method of competing and behaving for survival. Usually, a species will select a niche for which it is best adapted. The danger arises when multiple species begin competing for the same niche, which can cause an extinction \u2013 there can be only so many species doing the same thing before limited resources give out.\n'
  }, {
    name: 'Dunbar\u2019s Number',
    category: 'The Biological World',
    description: '\nThe primatologist Robin Dunbar observed through study that the number of individuals a primate can get to know and trust closely is related to the size of its neocortex. Extrapolating from his study of primates, Dunbar theorized that the Dunbar number for a human being is somewhere in the 100\u2013250 range, which is supported by certain studies of human behavior and social networks.\n'
  }]
};

var biologicalWorld = {
  state: state
};
/* harmony default export */ __webpack_exports__["a"] = (biologicalWorld);

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  models: [{
    name: 'Trust',
    category: 'Human Nature & Judgment',
    description: '\nFundamentally, the modern world operates on trust. Familial trust is generally a given (otherwise we\u2019d have a hell of a time surviving), but we also choose to trust chefs, clerks, drivers, factory workers, executives, and many others. A trusting system is one that tends to work most efficiently; the rewards of trust are extremely high.\n'
  }, {
    name: 'Bias from Incentives',
    category: 'Human Nature & Judgment',
    description: '\nHighly responsive to incentives, humans have perhaps the most varied and hardest to understand set of incentives in the animal kingdom. This causes us to distort our thinking when it is in our own interest to do so. A wonderful example is a salesman truly believing that his product will improve the lives of its users. It\u2019s not merely convenient that he sells the product; the fact of his selling the product causes a very real bias in his own thinking.\n'
  }, {
    name: 'Pavlovian Mere Association',
    category: 'Human Nature & Judgment',
    description: '\nIvan Pavlov very effectively demonstrated that animals can respond not just to direct incentives but also to associated objects; remember the famous dogs salivating at the ring of a bell. Human beings are much the same and can feel positive and negative emotion towards intangible objects, with the emotion coming from past associations rather than direct effects.\n'
  }, {
    name: 'Tendency to Feel Envy & Jealousy',
    category: 'Human Nature & Judgment',
    description: '\nHumans have a tendency to feel envious of those receiving more than they are, and a desire \u201Cget what is theirs\u201D in due course. The tendency towards envy is strong enough to drive otherwise irrational behavior, but is as old as humanity itself. Any system ignorant of envy effects will tend to self-immolate over time.\n'
  }, {
    name: 'Tendency to Distort Due to Liking/Loving or Disliking/Hating',
    category: 'Human Nature & Judgment',
    description: '\nBased on past association, stereotyping, ideology, genetic influence, or direct experience, humans have a tendency to distort their thinking in favor of people or things that they like and against people or things they dislike. This tendency leads to overrating the things we like and underrating or broadly categorizing things we dislike, often missing crucial nuances in the process.\n'
  }, {
    name: 'Denial',
    category: 'Human Nature & Judgment',
    description: '\nAnyone who has been alive long enough realizes that, as the saying goes, \u201Cdenial is not just a river in Africa.\u201D This is powerfully demonstrated in situations like war or drug abuse, where denial has powerful destructive effects but allows for behavioral inertia. Denying reality can be a coping mechanism, a survival mechanism, or a purposeful tactic.\n'
  }, {
    name: 'Availability Heuristic',
    category: 'Human Nature & Judgment',
    description: '\nOne of the most useful findings of modern psychology is what Daniel Kahneman calls the Availability Bias or Heuristic: We tend to most easily recall what is salient, important, frequent, and recent. The brain has its own energy-saving and inertial tendencies that we have little control over \u2013 the availability heuristic is likely one of them. Having a truly comprehensive memory would be debilitating. Some sub-examples of the availability heuristic include the Anchoring and Sunk Cost Tendencies.\n'
  }, {
    name: 'Representativeness Heuristic',
    category: 'Human Nature & Judgment',
    description: '\nThe three major psychological findings that fall under Representativeness, also defined by Kahneman and his partner Tversky, are:\n\na. Failure to Account for Base Rates\n\nAn unconscious failure to look at past odds in determining current or future behavior.\n\nb. Tendency to Stereotype\n\nThe tendency to broadly generalize and categorize rather than look for specific nuance. Like availability, this is generally a necessary trait for energy-saving in the brain.\n\nc. Failure to See False Conjunctions\n\nMost famously demonstrated by the Linda Test, the same two psychologists showed that students chose more vividly described individuals as more likely to fit into a predefined category than individuals with broader, more inclusive, but less vivid descriptions, even if the vivid example was a mere subset of the more inclusive set. These specific examples are seen as more representative of the category than those with the broader but vaguer descriptions, in violation of logic and probability.\n'
  }, {
    name: 'Social Proof (Safety in Numbers)',
    category: 'Human Nature & Judgment',
    description: '\nHuman beings are one of many social species, along with bees, ants, and chimps, among many more. We have a DNA-level instinct to seek safety in numbers and will look for social guidance of our behavior. This instinct creates a cohesive sense of cooperation and culture which would not otherwise be possible, but also leads us to do foolish things if our group is doing them as well.\n'
  }, {
    name: 'Narrative Instinct',
    category: 'Human Nature & Judgment',
    description: '\nHuman beings have been appropriately called \u201Cthe storytelling animal\u201D because of our instinct to construct and seek meaning in narrative. It\u2019s likely that long before we developed the ability to write or to create objects, we were telling stories and thinking in stories. Nearly all social organizations, from religious institutions to corporations to nation-states, run on constructions of the narrative instinct.\n'
  }, {
    name: 'Curiosity Instinct',
    category: 'Human Nature & Judgment',
    description: '\nWe like to call other species curious, but we are the most curious of all, an instinct which led us out of the savanna and led us to learn a great deal about the world around us, using that information to create the world in our collective minds. The curiosity instinct leads to unique human behavior and forms of organization like the scientific enterprise. Even before there were direct incentives to innovate, humans innovated out of curiosity.\n'
  }, {
    name: 'Language Instinct',
    category: 'Human Nature & Judgment',
    description: '\nThe psychologist Steven Pinker calls our DNA-level instinct to learn grammatically constructed language the Language Instinct. The idea that grammatical language is not a simple cultural artifact was first popularized by the linguist Noam Chomsky. As we saw with the narrative instinct, we use these instincts to create shared stories, as well as to gossip, solve problems, and fight, among other things. Grammatically ordered language theoretically carries infinite varying meaning.\n'
  }, {
    name: 'First-Conclusion Bias',
    category: 'Human Nature & Judgment',
    description: '\nAs Charlie Munger famously pointed out, the mind works a bit like a sperm and egg: the first idea gets in and then the mind shuts. Like many other tendencies, this is probably an energy-saving device. Our tendency to settle on first conclusions leads us to accept many erroneous results and cease asking questions; it can be countered with some simple and useful mental routines.\n'
  }, {
    name: 'Tendency to Overgeneralize from Small Samples',
    category: 'Human Nature & Judgment',
    description: '\nIt\u2019s important for human beings to generalize; we need not see every instance to understand the general rule, and this works to our advantage. With generalizing, however, comes a subset of errors when we forget about the Law of Large Numbers and act as if it does not exist. We take a small number of instances and create a general category, even if we have no statistically sound basis for the conclusion.\n'
  }, {
    name: 'Relative Satisfaction/Misery Tendencies',
    category: 'Human Nature & Judgment',
    description: '\nThe envy tendency is probably the most obvious manifestation of the relative satisfaction tendency, but nearly all studies of human happiness show that it is related to the state of the person relative to either their past or their peers, not absolute. These relative tendencies cause us great misery or happiness in a very wide variety of objectively different situations and make us poor predictors of our own behavior and feelings.\n'
  }, {
    name: 'Commitment & Consistency Bias',
    category: 'Human Nature & Judgment',
    description: '\nAs psychologists have frequently and famously demonstrated, humans are subject to a bias towards keeping their prior commitments and staying consistent with our prior selves when possible. This trait is necessary for social cohesion: people who often change their conclusions and habits are often distrusted. Yet our bias towards staying consistent can become, as one wag put it, a \u201Chobgoblin of foolish minds\u201D \u2013 when it is combined with the first-conclusion bias, we end up landing on poor answers and standing pat in the face of great evidence.\n'
  }, {
    name: 'Hindsight Bias',
    category: 'Human Nature & Judgment',
    description: '\nOnce we know the outcome, it\u2019s nearly impossible to turn back the clock mentally. Our narrative instinct leads us to reason that we knew it all along (whatever \u201Cit\u201D is), when in fact we are often simply reasoning post-hoc with information not available to us before the event. The hindsight bias explains why it\u2019s wise to keep a journal of important decisions for an unaltered record and to re-examine our beliefs when we convince ourselves that we knew it all along.\n'
  }, {
    name: 'Sensitivity to Fairness',
    category: 'Human Nature & Judgment',
    description: '\nJustice runs deep in our veins. In another illustration of our relative sense of well-being, we are careful arbiters of what is fair. Violations of fairness can be considered grounds for reciprocal action, or at least distrust. Yet fairness itself seems to be a moving target. What is seen as fair and just in one time and place may not be in another. Consider that slavery has been seen as perfectly natural and perfectly unnatural in alternating phases of human existence.\n'
  }, {
    name: 'Tendency to Overestimate Consistency of Behavior (Fundamental Attribution Error)',
    category: 'Human Nature & Judgment',
    description: '\nWe tend to over-ascribe the behavior of others to their innate traits rather than to situational factors, leading us to overestimate how consistent that behavior will be in the future. In such a situation, predicting behavior seems not very difficult. Of course, in practice this assumption is consistently demonstrated to be wrong, and we are consequently surprised when others do not act in accordance with the \u201Cinnate\u201D traits we\u2019ve endowed them with.\n'
  }, {
    name: 'Influence of Authority',
    category: 'Human Nature & Judgment',
    description: '\nThe equally famous Stanford Prison Experiment and Milgram Experiments demonstrated what humans had learned practically many years before: the human bias towards being influenced by authority. In a dominance hierarchy such as ours, we tend to look to the leader for guidance on behavior, especially in situations of stress or uncertainty. Thus, authority figures have a responsibility to act well, whether they like it or not.\n'
  }, {
    name: 'Influence of Stress (Including Breaking Points)',
    category: 'Human Nature & Judgment',
    description: '\nStress causes both mental and physiological responses and tends to amplify the other biases. Almost all human mental biases become worse in the face of stress as the body goes into a fight-or-flight response, relying purely on instinct without the emergency brake of Daniel Kahneman\u2019s \u201CSystem 2\u201D type of reasoning. Stress causes hasty decisions, immediacy, and a fallback to habit, thus giving rise to the elite soldiers\u2019 motto: \u201CIn the thick of battle, you will not rise to the level of your expectations, but fall to the level of your training.\u201D\n'
  }, {
    name: 'Survivorship Bias',
    category: 'Human Nature & Judgment',
    description: '\nA major problem with historiography \u2013 our interpretation of the past \u2013 is that history is famously written by the victors. We do not see what Nassim Taleb calls the \u201Csilent grave\u201D \u2013 the lottery ticket holders who did not win. Thus, we over-attribute success to things done by the successful agent rather than to randomness or luck, and we often learn false lessons by exclusively studying victors without seeing all of the accompanying losers who acted in the same way but were not lucky enough to succeed.\n'
  }, {
    name: 'Tendency to Want to Do Something (Fight/Flight, Intervention, Demonstration of Value, etc.)',
    category: 'Human Nature & Judgment',
    description: '\nWe might term this Boredom Syndrome: Most humans have the tendency to need to act, even when their actions are not needed. We also tend to offer solutions even when we do not enough knowledge to solve the problem.\n'
  }, {
    name: 'The IKEA Effect',
    category: 'Human Nature & Judgment',
    credit: 'https://en.m.wikipedia.org/wiki/IKEA_effect',
    description: '\nA cognitive bias in which consumers place a disproportionately high value on products they partially created. The name derives from the name of Swedish manufacturer and furniture retailer IKEA, which sells many furniture products that require assembly.\n\nThe IKEA effect has been described as follows: "The price is low for IKEA products largely because they take labor out of the equation. With a Phillips screwdriver, an Allen wrench and rubber mallet, IKEA customers can very literally build an entire home\'s worth of furniture on a very tight budget. But what happens when they do?" They "fall in love with their IKEA creations. Even when there are parts missing and the items are incorrectly built, customers in the IKEA study still loved the fruits of their labors."\n'
  }]
};

var humanNature = {
  state: state
};
/* harmony default export */ __webpack_exports__["a"] = (humanNature);

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  models: [{
    name: 'Opportunity Costs',
    category: 'Microeconomics & Strategy',
    description: '\nDoing one thing means not being able to do another. We live in a world of trade-offs, and the concept of opportunity cost rules all. Most aptly summarized as \u201Cthere is no such thing as a free lunch.\u201D\n'
  }, {
    name: 'Creative Destruction',
    category: 'Microeconomics & Strategy',
    description: '\nCoined by economist Joseph Schumpeter, the term \u201Ccreative destruction\u201D describes the capitalistic process at work in a functioning free-market system. Motivated by personal incentives (including but not limited to financial profit), entrepreneurs will push to best one another in a never-ending game of creative one-upmanship, in the process destroying old ideas and replacing them with newer technology. Beware getting left behind.\n'
  }, {
    name: 'Comparative Advantage',
    category: 'Microeconomics & Strategy',
    description: '\nThe Scottish economist David Ricardo had an unusual and non-intuitive insight: Two individuals, firms, or countries could benefit from trading with one another even if one of them was better at everything. Comparative advantage is best seen as an applied opportunity cost: If it has the opportunity to trade, an entity gives up free gains in productivity by not focusing on what it does best.\n'
  }, {
    name: 'Specialization (Pin Factory)',
    category: 'Microeconomics & Strategy',
    description: '\nAnother Scottish economist, Adam Smith, highlighted the advantages gained in a free-market system by specialization. Rather than having a group of workers each producing an entire item from start to finish, Smith explained that it\u2019s usually far more productive to have each of them specialize in one aspect of production. He also cautioned, however, that each worker might not enjoy such a life; this is a trade-off of the specialization model.\n'
  }, {
    name: 'Seizing the Middle',
    category: 'Microeconomics & Strategy',
    description: '\nIn chess, the winning strategy is usually to seize control of the middle of the board, so as to maximize the potential moves that can be made and control the movement of the maximal number of pieces. The same strategy works profitably in business, as can be demonstrated by John D. Rockefeller\u2019s control of the refinery business in the early days of the oil trade and Microsoft\u2019s control of the operating system in the early days of the software trade.\n'
  }, {
    name: 'Trademarks, Patents, and Copyrights',
    category: 'Microeconomics & Strategy',
    description: '\nThese three concepts, along with other related ones, protect the creative work produced by enterprising individuals, thus creating additional incentives for creativity and promoting the creative-destruction model of capitalism. Without these protections, information and creative workers have no defense against their work being freely distributed.\n'
  }, {
    name: 'Double-Entry Bookkeeping',
    category: 'Microeconomics & Strategy',
    description: '\nOne of the marvels of modern capitalism has been the bookkeeping system introduced in Genoa in the 14th century. The double-entry system requires that every entry, such as income, also be entered into another corresponding account. Correct double-entry bookkeeping acts as a check on potential accounting errors and allows for accurate records and thus, more accurate behavior by the owner of a firm.\n'
  }, {
    name: 'Utility (Marginal, Diminishing, Increasing)',
    category: 'Microeconomics & Strategy',
    description: '\nThe usefulness of additional units of any good tends to vary with scale. Marginal utility allows us to understand the value of one additional unit, and in most practical areas of life, that utility diminishes at some point. On the other hand, in some cases, additional units are subject to a \u201Ccritical point\u201D where the utility function jumps discretely up or down. As an example, giving water to a thirsty man has diminishing marginal utility with each additional unit, and can eventually kill him with enough units.\n'
  }, {
    name: 'Bottlenecks',
    category: 'Microeconomics & Strategy',
    description: '\nA bottleneck describes the place at which a flow (of a tangible or intangible) is stopped, thus holding it back from continuous movement. As with a clogged artery or a blocked drain, a bottleneck in production of any good or service can be small but have a disproportionate impact if it is in the critical path.\n'
  }, {
    name: 'Prisoner\u2019s Dilemma',
    category: 'Microeconomics & Strategy',
    description: '\nThe Prisoner\u2019s Dilemma is a famous application of game theory in which two prisoners are both better off cooperating with each other, but if one of them cheats, the other is better off cheating. Thus the dilemma. This model shows up in economic life, in war, and in many other areas of practical human life. Though the prisoner\u2019s dilemma theoretically leads to a poor result, in the real world, cooperation is nearly always possible and must be explored.\n'
  }, {
    name: 'Bribery',
    category: 'Microeconomics & Strategy',
    description: '\nOften ignored in mainstream economics, the concept of bribery is central to human systems: Given the chance, it is often easier to pay a certain agent to look the other way than to follow the rules. The enforcer of the rules is then neutralized. This principle/agent problem can be seen as a form of arbitrage.\n'
  }, {
    name: 'Arbitrage',
    category: 'Microeconomics & Strategy',
    description: '\nGiven two markets selling an identical good, an arbitrage exists if the good can profitably be bought in one market and sold at a profit in the other. This model is simple on its face, but can present itself in disguised forms: The only gas station in a 50-mile radius is also an arbitrage as it can buy gasoline and sell it at the desired profit (temporarily) without interference. Nearly all arbitrage situations eventually disappear as they are discovered and exploited.\n'
  }, {
    name: 'Supply and Demand',
    category: 'Microeconomics & Strategy',
    description: '\nThe basic equation of biological and economic life is one of limited supply of necessary goods and competition for those goods. Just as biological entities compete for limited usable energy, so too do economic entities compete for limited customer wealth and limited demand for their products. The point at which supply and demand for a given good are equal is called an equilibrium; however, in practical life, equilibrium points tend to be dynamic and changing, never static.\n'
  }, {
    name: 'Scarcity',
    category: 'Microeconomics & Strategy',
    description: '\nGame theory describes situations of conflict, limited resources, and competition. Given a certain situation and a limited amount of resources and time, what decisions are competitors likely to make, and which should they make? One important note is that traditional game theory may describe humans as more rational than they really are. Game theory is theory, after all.\n'
  }]
};

var microeconomics = {
  state: state
};
/* harmony default export */ __webpack_exports__["a"] = (microeconomics);

/***/ }),

/***/ 370:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var state = {
  models: [{
    name: 'Seeing the Front',
    category: 'Military & War',
    description: '\nOne of the most valuable military tactics is the habit of \u201Cpersonally seeing the front\u201D before making decisions \u2013 not always relying on advisors, maps, and reports, all of which can be either faulty or biased. The Map/Territory model illustrates the problem with not seeing the front, as does the incentive model. Leaders of any organization can generally benefit from seeing the front, as not only does it provide firsthand information, but it also tends to improve the quality of secondhand information.\n'
  }, {
    name: 'Asymmetric Warfare',
    category: 'Military & War',
    description: '\nThe asymmetry model leads to an application in warfare whereby one side seemingly \u201Cplays by different rules\u201D than the other side due to circumstance. Generally, this model is applied by an insurgency with limited resources. Unable to out-muscle their opponents, asymmetric fighters use other tactics, as with terrorism creating fear that\'s disproportionate to their actual destructive ability.\n'
  }, {
    name: 'Two-Front War',
    category: 'Military & War',
    description: '\nThe Second World War was a good example of a two-front war. Once Russia and Germany became enemies, Germany was forced to split its troops and send them to separate fronts, weakening their impact on either front. In practical life, opening a two-front war can often be a useful tactic, as can solving a two-front war or avoiding one, as in the example of an organization tamping down internal discord to focus on its competitors.\n'
  }, {
    name: 'Counterinsurgency',
    category: 'Military & War',
    description: '\nThough asymmetric insurgent warfare can be extremely effective, over time competitors have also developed counterinsurgency strategies. Recently and famously, General David Petraeus of the United States led the development of counterinsurgency plans that involved no additional force but substantial additional gains. Tit-for-tat warfare or competition will often lead to a feedback loop that demands insurgency and counterinsurgency.\n'
  }, {
    name: 'Mutually Assured Destruction',
    category: 'Military & War',
    description: '\nSomewhat paradoxically, the stronger two opponents become, the less likely they may be to destroy one another. This process of mutually assured destruction occurs not just in warfare, as with the development of global nuclear warheads, but also in business, as with the avoidance of destructive price wars between competitors. However, in a fat-tailed world, it is also possible that mutually assured destruction scenarios simply make destruction more severe in the event of a mistake (pushing destruction into the \u201Ctails\u201D of the distribution).\n'
  }]
};

var war = {
  state: state
};
/* harmony default export */ __webpack_exports__["a"] = (war);

/***/ }),

/***/ 372:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 373:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[134]);


// WEBPACK FOOTER //
// static/js/app.0a95ce22be8c91587ef3.js